import { FC, useState } from 'react'
import { SequenceMenu } from '@sequencehq/core-components'
import { SendTestCreditNoteDialog } from 'CreditNotes/components/dialog/SendTestCreditNoteDialog'

type Props = {
  creditNoteId: string
}

export const SendTestCreditNoteMenuItem: FC<Props> = ({ creditNoteId }) => {
  const [showModal, setShowModal] = useState(false)

  return (
    <>
      <SequenceMenu.Item
        uuid="send-test-credit-note"
        data-testid={`creditNotes.${creditNoteId}.menuItem.sendTest`}
        label="Send test email"
        onClick={e => {
          e.stopPropagation()
          setShowModal(true)
        }}
      />
      {showModal && (
        <SendTestCreditNoteDialog
          creditNoteId={creditNoteId}
          isOpen
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  )
}
